<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  variant?: 'default' | 'secondary' | 'outline' | 'destructive' | 'success' | 'warning';
  className?: string;
}>();

const variants = {
  default: 'bg-slate-900 text-slate-50 hover:bg-slate-900/80',
  secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-100/80',
  outline: 'text-slate-950 border border-slate-200',
  destructive: 'bg-red-500 text-slate-50 hover:bg-red-500/80',
  success: 'bg-emerald-100 text-emerald-800 border-emerald-200 border',
  warning: 'bg-amber-100 text-amber-800 border-amber-200 border',
};
</script>

<template>
  <div :class="`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 ${variants[variant || 'default']} ${className || ''}`">
    <slot />
  </div>
</template>